"use strict";
/**
 * API helper functions for User Management endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.userApi = void 0;
const apiClient_1 = require("./apiClient");
const validation_1 = require("./validation");
exports.userApi = {
    /**
     * Fetch all users
     */
    getAll() {
        return apiClient_1.apiClient.get('/users').then(res => res.usersData);
    },
    /**
     * Create a new user
     */
    create(data) {
        return apiClient_1.apiClient.post('/user', data);
    },
    /**
     * Update an existing user
     */
    update(data) {
        return apiClient_1.apiClient.put('/user', data);
    },
    /**
     * Delete a user by ID.
     * retry: false — avoids retrying destructive operations on 500
     */
    deleteUser(id) {
        (0, validation_1.validateId)(id, 'User ID');
        return apiClient_1.apiClient.delete(`/user/${id}`, { retry: false });
    },
};
